import { hookstate } from '@hookstate/core';

export interface ParcelPlaybackStateInterface {
  darkMode: boolean;
  isAdmin: boolean | undefined;
  selectedRegion: string | undefined;
  selectedSite:
    | {
        siteCode: string;
        vms: string;
      }
    | undefined;
  stage: string | undefined;
  username: string | undefined;
}

export const parcelPlaybackBaseState = hookstate<ParcelPlaybackStateInterface>({
  darkMode: false,
  isAdmin: undefined,
  selectedRegion: undefined,
  selectedSite: undefined,
  stage: 'gamma',
  username: undefined,
});
